import clsx from 'clsx';
import { useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';

import Modal from '../Modal/Modal';

import s from './DeclinedBadge.module.scss';

export function DeclinedBadge({ reason }: { reason?: string }) {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <span
        className={clsx(s.badge, !!reason && s.clickable)}
        onClick={(e) => {
          e.stopPropagation();
          if (reason) {
            setOpened(true);
          }
        }}
      >
        Declined
        {!!reason && (
          <span className={s.close}>
            <BiInfoCircle size={16} />
          </span>
        )}
      </span>
      {opened && (
        <Modal open title="Decline reason" onClose={() => setOpened(false)}>
          <p className={s.declineReason}>{reason}</p>
        </Modal>
      )}
    </>
  );
}
